module.exports = __webpack_public_path__ + "img/ic_18plus.4ad6d7bf.svg";